/** Brazilian national holidays (plus Carnival and Corpus Christi, which close most offices) for a year. */
export type Holiday = Readonly<{ date: string; key: string }>;

const pad = (value: number): string => String(value).padStart(2, "0");
const iso = (date: Date): string => `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;

/** Anonymous Gregorian algorithm for Easter Sunday. */
const easter = (year: number): Date => {
  const a = year % 19, b = Math.floor(year / 100), c = year % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(year, month - 1, day));
};

const shifted = (base: Date, days: number): string => iso(new Date(base.getTime() + days * 86_400_000));

export const brazilianHolidays = (year: number): readonly Holiday[] => {
  const base = easter(year);
  return [
    { date: `${year}-01-01`, key: "newYear" }, { date: shifted(base, -48), key: "carnival" }, { date: shifted(base, -47), key: "carnival" },
    { date: shifted(base, -2), key: "goodFriday" }, { date: `${year}-04-21`, key: "tiradentes" }, { date: `${year}-05-01`, key: "labour" },
    { date: shifted(base, 60), key: "corpusChristi" }, { date: `${year}-09-07`, key: "independence" }, { date: `${year}-10-12`, key: "ourLady" },
    { date: `${year}-11-02`, key: "allSouls" }, { date: `${year}-11-15`, key: "republic" }, { date: `${year}-11-20`, key: "blackAwareness" },
    { date: `${year}-12-25`, key: "christmas" },
  ];
};
